import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantOverviewPage } from './merchant-overview';

@NgModule({
  declarations: [
    MerchantOverviewPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantOverviewPage),
    TranslateModule.forChild()
  ],
})
export class MerchantOverviewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview/merchant-overview.module.ts